<template>
  <aside class="p-4 space-y-4" :class="`fixed flex-shrink-0 lg:relative lg:left-0 top-0 z-10 transition-all h-screen ${isOpen ? 'sidebar__open' : 'sidebar__closed'}`">
    <AmsSidebarHeader class="border-b border-white" />
    <AmsSidebarMenu />
  </aside>
</template>

<script>
import AmsSidebarMenu from './AmsSidebarMenu.vue';
import AmsSidebarHeader from './AmsSidebarHeader.vue';
export default {
  components: {
    AmsSidebarMenu,
    AmsSidebarHeader,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped lang="scss">
aside {
  // --sidebar-width: 18rem;
  // width: min(var(--sidebar-width), 90vw);
  background-color: #1e1e2d;
  color: white;
  height: 100vh;
}

@media  (max-width: #{theme('screens.sm')}){
    aside {
    --sidebar-width: 80vw;
     width: min(var(--sidebar-width), 90vw);
  }
}

@media (min-width: #{theme('screens.sm')}){
  aside {
    --sidebar-width: 18rem;
     width: min(var(--sidebar-width), 90vw);
  }
}

.sidebar__open {
  left: 0;
}

.sidebar__closed {
  left: calc(-1 * var(--sidebar-width));
}
</style>
